const sizes = {
    mobile: '425px',
    tablet: '768px',
    laptop: '1024px',
};

export const breakpoints = Object.fromEntries(Object.entries(sizes).map(([k, v], i) => [k, `max-width: ${v}`]));